import { TypeGuards } from '@codeleap/types'
import { Profile } from './views'

const verify = (v) => !TypeGuards.isNil(v)

type CheckSignupCompletionResponse = {
  isComplete: boolean
  nextStep?: string
  modal?: string
}
export async function checkSignupCompletion(data: Profile): Promise<CheckSignupCompletionResponse> {
  // const firebase = await getFirebase()

  const signupInfo = [
    data?.first_name,
    data?.last_name,
    data?.email,
  ]

  const hasCompletedSignup = signupInfo.every(verify)

  const personalInfo = [
    data?.birthday,
    data?.gender,
    data?.country,
  ]

  const hasCompletedPersonalInfo = personalInfo.every(verify)

  const orgInfo = [
    data?.seniority,
    data?.organization?.id,
    data?.department,
  ]

  const hasCompletedOrganizationInfo = orgInfo.every(verify)

  logger.debug('Signup completion', { signupInfo, personalInfo, orgInfo }, 'Auth')

  const steps = [
    ['signup', hasCompletedSignup],
    ['aboutYou', hasCompletedPersonalInfo],
    ['aboutJob', hasCompletedOrganizationInfo],
  ] as const

  const nextStep = steps.find(x => !x?.[1])?.[0]

  const isComplete = steps.every(x => x?.[1])

  // if (isComplete && !(await isEmailVerified(data))) {
  //   return {
  //     isComplete: false,
  //     nextStep: 'VerifyEmail',
  //     modal: 'verifyEmailBefore',
  //   }
  // }

  return {
    isComplete,
    nextStep,
  }
}
